var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDeliveryGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 263,
    viewBox: "0 0 215 263",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zg29adowwa",
    d: "M0 263h173V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207 40.5c2.071 0 3.946.84 5.303 2.197A7.477 7.477 0 0 1 214.5 48v214.5H.5V48c0-2.071.84-3.946 2.197-5.303A7.477 7.477 0 0 1 8 40.5z",
    fill: "#FC5726"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.375 77.092c4.135 10.653 19.774 11.726 22.75-.511 8.54-1.492 12.581 6.014 15.198 13.774 1.637 4.853 3.037 9.807 3.645 12.72-4.902 3.059-8.69 4.017-8.69 4.272 0 4.477-2.295 11.64-2.568 16.213-.275 4.618.027 9.958-.01 15.192-.004.77-1.897.26-1.92 1.021-.118 3.931.643 8.937.31 12.308-14.046.115-29.437 1.16-43.368.458-.566-6.736 6.238-38.363-2.827-39.958-.461-7.83 2.205-15.16 3.727-22.34 1.028-4.851 11.095-15.91 15.295-11.618",
    fill: "#F69536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8AF66",
    d: "m106.209 86.212-31.534.787-2.989 23.144-1.61 28.45h33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.506 28.384c14.823-.512 15.845 18.274 10.712 27.87-2.795 5.224-7.94 8.762-14.206 8.038-6.14-.71-8.664-7.78-9.157-12.863-.46-4.753.51-9.832 2.135-14.062 2.335-6.074 5.883-8.228 10.13-8.983",
    fill: "#9C7141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.596 31.647c6.441-4.652 8.246-17.493-.733-19.448-3.81-.828-7.682.993-9.264 5.244-1.708 4.593-1.18 8.775 1.153 12.447",
    fill: "#68493B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.26 64.386c-.865 5.437-1.59 10.114-3.285 14.187M82.12 61.112c-1.018 3.945-3.344 15.075-3.283 14.13",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.93 42.19c-7.498-4.117-9.442 10.703-1.25 11.283M104.764 44.845c7.627-1.351 5.31 11.194-1.84 10.802",
    fill: "#9C7141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.304 48.017c-1.315 1.486-1.852 2.38-3.285 3.273M79.93 46.925c-.009-.007-3.168-3.186-3.284-3.274M99.293 43.651c-.05 1.577-.05 2.668-.403 4.366M87.249 43.651c-.102 1.74-.252 2.2-.403 3.274M95.13 43.651c.05 1.562 1.008 9.015-3.155 5.714",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.153 54.274c-4.295 0-6.944-.12-10.63-1.892-.22 3.495 1.13 5.798 4.078 6.396 4.022.817 5.804-1.82 6.848-4.504",
    fill: "#F0612B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.07 76.203c3.344-.86 5.046-1.126 7.003-.713 2.914.614 5.382 1.88 7.109 4.441 2.01 2.98 2.83 6.518 3.903 9.93.915 2.905 1.791 5.792 2.613 8.715.936 3.319 2.279 9.586 2.365 9.46",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.574 108.968c1.855-3.072 12.126-16.736 15.177-21.6.92-1.465 1.807-2.972 3.567-3.213 1.833-.25 3.494.125 5.28.28 3.434.299 5.938.013 10.503-.406 0 1.686-4.57 2.52-5.85 2.64-1.898.18-5.061.176-6.563 1.397-1.112.905-8.205 18.67-12.554 24.876-1.74 2.482-3.34 4.66-5.857 6.507-1.555 1.14-4.39 2.052-6.414 1.536-2.636-.674-5.647-5.114-7.654-8.726",
    fill: "#9C7141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.986 82.52c-4.54 0-10.853 1.06-15.023-.199-1.655-.5-3.257-2.061-4.3-3.381-.925-1.174-.685-1.178.078-2.187 6.221-8.223 38.67-5.614 42.218-4.675 4.216 1.119 9.617 3.193 12.946 5.87-3.556 4.503-16.663 4.428-19.885 4.357",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.253 77.225c6.311 0 37.48-.905 44.893-.452M119.965 74.207c-2.035-.917-4.085-2.776-4.76-4.951-1.026-3.309 1.446-3.865 4.151-4.56 8.005-2.053 16.739-2.761 25.103-2.404 7.711.329 15.96 1.894 23.174 4.593 2.5.936 2.92 2.96.32 4.347-2.072 1.105-4.46 1.283-6.63 1.875-.432.118-.834.24-1.285.283.032.204.14.037.277.11",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.92 64.386c1.735-.439 5.095-1.673 5.543-3.59 1.156-4.957-14.073-5.02-18.651-5.407a218.493 218.493 0 0 0-17.769-.749c-4.115 0-5.4-.246-9.467.15-1.419.138-5.971 1.95-6.553 4.198-.585 2.256 3.689 4.696 5.68 5.248M162.877 55.568c1.515.19 8.578.2 9.028-1.322-6.87-1.747-14.034-3.11-21.178-4.272-6.353-1.033-12.785-.974-19.193-.68-5.75.264-12.087.554-17.66 2.073 2.642 1.197 6.65 2.323 9.568 2.098",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.397 51.514c0-3.014-.13-4.418.034-7.86 3.289-.024 43.715.174 43.715.324 0 2.738 0 6.179-.144 9.495M122.663 43.373c-.076-2.047 0-2.363.152-5.003 1.944-.288 12.117-.138 14.821-.117.09 1.663.203 5.467.326 5.398M136.867 37.669c1.487-1.474 4.924-1.934 6.96-2.14 3.24-.33 6.673-.727 9.958-.574 4.382.204 10.186.93 13.26 4.458 1.558 1.787-1.017 3.25-2.884 3.694-.037.177-.04.36-.026.544",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.922 36.547c.407-.927 1.474-2.235 1.17-3.294-.3-1.043-1.921-1.523-2.924-1.793-3.35-.9-7.047-1.154-10.561-1.502-8.283-.82-17.238-.584-25.409.457-1.566.2-4.054.547-4.71 2.206-.589 1.489.795 4.913 2.08 5.574",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.472 30.451c-3.654.001-7.861-.277-11.124-1.794 2.083-1.076 5.225-1.094 7.575-1.35 3.709-.405 7.519-.726 11.295-.896 7.677-.347 15.87-.552 23.226 1.536.59.166 1.146.245 1.702.598-1.011 1.71-3.811 2.562-5.147 3.102",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "0fe2bone4b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zg29adowwa"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)",
    d: "M154.386 49.108h6.57v-4.365h-6.57zM79.93 76.39c-5 0-10.53.768-14.362 4.23-3.85 3.478-6.553 8.18-7.536 13.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.354 76.39c-.867 5.957-5.357 9.017-10.123 9.7-5.594.805-10.484-2.46-12.471-7.748-.15-.396-.358-.904-.4-1.23",
    fill: "#9C7141",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.835 106.946c-4.597 5.027-10.35 10.459-14.234 15.278M57.336 93.85c-1.827 5.899-2.695 13.439-2.579 19.611 2.577.13 10.811-.185 14.224.014M70.076 100.398c-.157 6.621-.78 10.116-1.095 16.37M124.914 26.992c-4.929.587-15.385-4.574-6.46-7.037 6.138-1.692 14.2-1.196 20.625-1.257 7.333-.068 15.467-.644 22.462 1.085 1.963.485 6.488 1.376 5.938 3.704-.327 1.393-5.053 3.268-5.547 3.795",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.578 19.643c10.841-9.902-15.871-10.586-20.486-10.787-4.396-.191-11.135-.368-15.087 1.106-3.345 1.246-5.22 7.03-1.15 8.565M128.857 9.822l-.403-8.731M127.013.546h30.658M158.218 1.091v10.913M87.595 89.595c5.893 0 8.96 1.047 14.234.846M102.924 91.668c-.5 6.495-4.16 27.171-4.38 32.739",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.64 123.315c-5.691-.171-9.569-1.09-14.235-1.09M87.595 111.311c-.14 2.68-.789 7.483-1.095 10.913M87.455 90.577l-.815 6.547M101.829 90.577l-5.475 10.913M95.259 108.037l5.475 15.278M88.69 90.577l8.759 6.547M96.354 115.676l-10.949 6.548M96.161 103.672l-.708 3.274M116.063 102.581l-8.759 4.365",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.907 86.212c1.184 4.799-1.46 51.544-1.981 52.333-.8 1.213-3.17 1.026-4.599 1.022-6.645-.016-26.196.38-28.279-.196-1.56-.43-.775-4.959-.775-5.472",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36 112.402c-.002-6.497 2.354-24.312 2.849-24.94.62-.788 20.88-1.129 23.545-1.16 1.54-.018 5.316-.194 6.455 0",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.595 91.668c-2.868 0-11.281.372-11.281.743 0 3.912-.382 10.604-.763 15.626M76.646 124.407c.137 2.214.19 6.292.19 8.58 0 .19 15.327.219 20.201-.029.447-2.75.412-5.65.412-8.551M102.116 138.593c.297 7.156.673 10.55.457 14.187M60.222 137.502c-.86 3.533-3.167 9.467-3.285 16.37M101.83 152.034c-8.02 0-36.131.247-43.798.401",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.543 152.883c-.004 7.943.056 16.191-.345 24.222-6.372.33-12.266.785-18.604.408-.616-1.993-.907-5.05-1.308-7.077-3.116 3.72-4.582 7.444-5.357 7.444-4.84 0-13.34-.402-18.182-.834 1.106-6.648 3.434-16.513 5.762-24.266",
    fill: "#93C4BD",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.354 176.788c-1.194 15.646-1.545 21.944-3.185 32.383-1.75 11.138-3.967 22.112-5.574 33.095M88.788 242.266c-.365 4.411-1.27 8.692-1.462 12.303 3.876.227 7.724 1.41 11.35 2.668 3.447 1.197 8.782 4.062 2.267 4.505-5.508.375-24.079 0-23.17 0M79.93 175.697c0 25.929-4.38 50.339-4.38 76.254 0 3.11.094 6.351 1.23 8.866M85.405 197.523c.496 2.304 2.272 4.818 4.38 6.548",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.595 254.27c-2.004 2.437-9.985 4.873-10.95 1.91M86.5 247.378c-3.721-.014-8.034-.403-10.95-.403M90.859 254.27c-.27 1.515-1.04 3.317-1.053 3.273M93.043 255.361c-.47 1.493-1.566 3.517-.746 3.25",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36 177.624c-1.913 5.227-5.764 33.828-14.862 30.55-5.118-1.842-9.604-11.02-11.914-15.498-3.364-6.519-5.111-12.688-8.473-19.06-2.314-4.386-2.7-5.272-7.777-6.03-2.476-.37-10.496-.128-10.625-3.076 7.658-1.224 16.954-.83 24.874-.371 3.833 7.555 5.66 13.729 11.126 20.075",
    fill: "#9C7141",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.032 174.606c-1.356 6.545-4.546 11.99-2.75 19.643M47.082 165.876c-2.06 0-11.878 1.446-10.878 3.273M51.462 174.606c-2.155.54-8.154 2.343-8.76 3.274M37.228 163.693c-.64 1.405-1.236 3.01-1.066 3.274M32.848 163.693a11.16 11.16 0 0 1-1.095 3.274M44.048 162.329c3.181.083 8.747-.603 10.699-3.07-2.855-2.77-14.08-2.007-18.318-2.045-7.615-.068-15.233 0-22.848 0-3.354 0-18.883 1.262-9.529 4.006 6.101 1.79 10.671 1.79 17.526 2.473M5.876 156.054l.292-6.548M6.57 150.253l39.417-.402M48.51 149.506l.43 6.548M7.338 149.092c-2.216-.052-5.596-2.589-6.1-4.762-.798-3.43 1.883-4.267 4.57-4.811 5.567-1.127 12.289-1.022 18.252-.735 6.233.3 12.623 1.034 18.625 2.205 2.134.417 6.009.562 7.599 2.218 1.715 1.787 1.733 5.277-1.12 6.273-.322.111-2.063-.175-1.539-.02",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.177 144.904c-7.116 1.06-14.667-1.744-21.758-2.43-6.508-.626-13.218-.607-19.85-.607M44.934 134.228c1.567-.431 2.712-2.236 1.855-3.684-.576-.973-3.89-1.174-4.966-1.414-3.872-.865-8.067-1.043-12.253-1.043-5.485 0-20.83-1.96-24.095 2.73 1.206 1.634 3.74 3.338 5.835 2.729",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.892 127.68c.015-2.157.395-4.22.328-6.307-7.593-.231-15.208-.382-22.888-.037-.127 2.297-.19 3.668.196 6.01M35.74 120.011c2-.014 3.985.245 5.868-.536-3.748-3.609-13.751-3.684-18.458-3.858-4.833-.18-13.332-2.297-17.675.11 1.961 2.724 6.038 3.888 8.997 4.284",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.272 176.961c-7.072.738-16.084-.449-16.105.173-.355 10.336-1.564 18.96-1.567 26.184-.004 14.293-2.858 29.73-2.954 42.915 1.934.095 10.096.56 11.395.34.722-.123 3.774-22.375 5.012-28.265 2.428-11.484 3.512-26.36 4.396-41.52",
    fill: "#9C7141",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.792 256.11c-.228 3.236-.394 4.324 1.148 5.5.82.625 20.318.114 26.026-.135.879-3.117-9.397-4.766-13.437-5.702-5.46-1.266-6.826.782-11.768.836M45.101 162.725c1.155 1.222 1.883 2.791 1.981 4.344-2.455-.658-7.152.85-9.756.979-2.743.137-1-1.154-3.629-1.407-4.342-.418-9.857.464-12.893-2.815 4.818-2.262 17.818-.674 24.427-.796",
    fill: "#F0612B",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.787 177.76c3.619-1.115 5.67-1.866 9.675-2.371-.972-3.128-3.861-7.919-4.507-8.11-3.212-.944-6.275.552-10.822.563.339 2.495 4.506 8.714 5.367 10.038",
    fill: "#FEFEFE",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.165 62.938c0 2.263-.526 4.257-.744 6.386-.208 2.05-.282 4.081-.642 6.092-.577 3.23-3.142 3.823-5.965 4.106-3.441.344-7.735.076-11.028-.954-1.074-.334-4.58-1.893-3.205-3.049 1.06-.89 4.509-.86 5.91-.927 1.532-.073 1.51-.112 1.791-1.59.191-.993.547-1.943.778-2.913.47-1.97.556-4.052 1.056-6.092.413-1.681.224-3.915 2.284-3.973 2.886-.082 5.374 1.395 8.094 1.59M118.181 110.88c.334-.73-.584-2.94-.882-3.81-.388-1.136-.67-2.262-1.171-3.395-.99-.063-2.246.872-3.182 1.218-1.025.379-2.088.677-3.052 1.138-.696.333-2.101.823-2.385 1.423-.338.715-.201 4.651.003 4.948M73.36 177.468c-4.252 0-8.499-.444-12.692-.667-1.483-.08-2.023.2-2.157 1.597-.102 1.063.148 1.947-.053 2.932-.167.824-.56 2.408-.38 3.208.306 1.38 1.432.987 2.687.7 1.887-.43 3.878-1.183 5.602-2.034",
    fill: "#9C7141",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 162.602c-2.58-.57-5.649-.387-8.362-.623-2.78-.242-5.578-.77-8.188-1.596-.798-.252-3.378-1.175-3.14-2.144.19-.778 2.695-.947 3.483-1.086a49.621 49.621 0 0 1 8.715-.779c11.398 0 23.275-.82 34.671.165 2.078.179 5.472.207 6.768 1.976-4.133 2.75-10.14 3.142-15.13 2.526-5.23-.646-11.693-.153-16.722.786-.195.037-1.059.194-.875.152",
    fill: "#C8AF66",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.209 43.651c-1.228-3.096-1.583-4.023-3.332-6.649-1.819-2.73-4.686-4.486-7.629-4.782-3.136-.318-5.922.819-8.418 2.733-2.511 1.925-3.95 4.612-5.805 6.848.413-8.078 7.778-13.817 12.645-13.407 8.136.684 11.772 7.242 12.473 13.088",
    fill: "#68493B",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.575 157.496c-.05-1.514.273-2.97.342-4.438.09-1.927-.533-2.67 1.326-3.017 2.643-.494 5.65-.064 8.329-.178 6.04-.258 12.314-.373 18.357-.355 3.722.01 7.382 1.168 10.978.914a73.5 73.5 0 0 1 0 6.87c-11.152.6-22.34-.027-33.496.559-1.066.056-2.202.161-3.298.217-.58.03-2.78.476-2.371-.217",
    fill: "#FEF398",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.262 126.592c.624-.549-.337-4.525.082-7.28 7.405-.398 16.07-.9 22.884 1.129-.3 2.665-1.104 5.39-1.072 8.33-5.631-.07-13.806-.9-18.142-1.613",
    fill: "#FEFEFE",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.418 119.404c-3.08.17-5.033-.797-6.943-3.983 3.298-1.793 10.69-.206 18.226.198 8.21.443 15.515.182 15.717 3.7-2.319.745-4.742.781-7.21.683",
    fill: "#FEF398",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.276 135.231c-2.78-1.428-4.683-2.317-4.793-3.195-.407-3.243 14.71-3.41 19.105-3.205 5.013.235 9.972.29 14.62 1.396 2.054.49 5.464.148 5.678 2.718.199 2.384-4.323 2.821-5.984 1.982",
    fill: "#C8AF66",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.35 91.668c-2.357.865-5.94.347-8.525.347-.9 0-3.641-.48-4.358-.008-.76.499-.652 2.923-.697 3.828-.286 5.751.01 11.599.01 17.36 0 3.34.343 6.537.173 9.895-.155 3.051.435 6.597.209 9.869 4.576.46 16.89-.11 20.296-.173.237-4.648.896-8.995.896-13.862 0-2.842.035-5.673.174-8.464.165-3.318-.98-6.476-.87-9.764",
    fill: "#FEFEFE",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.924 90.915c-2.845-1.003-6.089-.717-9.065-1.02-.893-.092-3.137-.746-3.921-.184-.746.533-.737 3.028-.817 3.95-.501 5.782-.437 11.532-1.585 17.16-.74 3.627-1.184 8.022-.99 11.815 4.213-.23 8.45.87 12.764.65-.302-5.622 1.19-10.9 1.526-16.411.166-2.72.729-5.422.89-8.067.086-1.38.002-2.853.135-4.156.103-1.025-.088-3.385.367-4.264.148-.284.137-.011.355-.16",
    fill: "#FEF398",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.74 106.43c.699-1.507.927-3.742 1.194-5.67.256-1.84.435-3.784 1.218-5.41 2.087.104.378 5.858 1.366 7.12 2.039-2.205 6.43-8.422 8.735-8.62.036 2.21-2.102 5.206-3.1 7.067 1.479-.985 5.695-5.697 7.679-5.04 1.88.622-3.988 5.234-4.491 6.28 2.297-.607 4.709-1.507 7.091-1.557.383 2.094-5.783 3.85-6.967 4.926 1.62.524 4.945-.75 6.078.677-2.442 1.7-4.802 2.42-6.614 2.927-2.291.639-5.242 1.785-7.06 4.364",
    fill: "#9C7141",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.405 112.402c-2.307 4.193-6.106 10.347-8.562 14.49-2.594 4.378-4.962 7.84-9.83 9.71-1.861.715-4.443 1.687-5.925-.179-1.589-1.998-2.16-3.814-2.536-6.265-.822-5.346-.534-11.375-.068-17.597",
    fill: "#9C7141",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.17 113.653c1.005-1.437 2.494-2.615 3.838-3.867 1.155-1.077 2.12-2.536 3.332-3.495 1.983-1.567 3.548 1.458 4.286 3.21.968 2.294.905 3.533-1.424 4.801-1.47.8-6.152 3.452-7.653 2.077",
    fill: "#9C7141",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.99 111.922c1.06.525-.033 3.801-.009 4.846 1.057-1.092 2.8-1.7 3.794-2.857.516-.6.753-1.06.455-1.738-.446-1.013-.88-.634-2.371-.862",
    fill: "#F69536",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.521 74.207c-1.801-1.023-4.219-3.217-4.511-5.24-.457-3.156 2.984-3.705 5.201-4.584 6.187-2.451 13.776-1.252 20.308-1.878 6.74-.646 14.323-.339 20.65 1.747 2.388.788 5.709 1.744 7.64 3.45 2.844 2.512-1.746 3.82-3.649 4.759-4.454 2.198-9.435 1.1-14.403.708-7.427-.587-14.894.057-22.212.514",
    fill: "#C8AF66",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.172 64.386c-1.888-.147-5.575-1.782-6.112-3.956-.716-2.894 2.951-4.358 4.883-4.875 5.349-1.429 11.623-.888 17.274-.9 2.964-.007 5.806.572 8.719.72 2.946.148 5.812.092 8.68.4 2.364.255 15.95 1.028 12.286 5.592-4.178 5.205-10.834 1.397-16.122 1.077-6.149-.373-12.17-.777-18.272.1-1.865.266-3.694.543-5.58.76-.993.114-1.983.21-2.97.356-.556.084-2.28.43-1.913.545",
    fill: "#93C4BD",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.453 52.42c.084-2.75-.444-5.623.295-8.407 14.045-.75 28.883-.218 43.053.545.156 3.273.508 6.837.257 10.006-3.14-.585-6.148-1.477-9.461-1.871-3.818-.455-7.633-1.364-11.552-1.364-6.801 0-16.271-1.241-22.079.818",
    fill: "#C8AF66",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.434 43.505c0-1.745.053-3.518-.04-5.249-4.877-.236-9.873.271-14.702.504a42.375 42.375 0 0 0 0 4.455c4.794.874 10.23.164 15.27.164",
    fill: "#9C7141",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.867 39.416c7.426-4.318 17.472-4.203 25.327-1.468 2.203.765 8.162 3.752 3.738 6.72-2.83 1.9-9.642.95-12.965.763-5.009-.28-10.42-.063-15.576-.28.244.291.178.311.457.42",
    fill: "#FEF398",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.868 38.134c-3.558 0-11.593.138-13.024-.001-1.64-.159-2.657-2.57-2.345-4.685.331-2.254 1.922-2.815 3.908-3.37 3.93-1.096 8.683-.432 12.764-.216 4.242.225 8.671-.339 12.764.262 3.438.506 8.145.058 11.201 1.67 1.656.873 2.778 1.82 1.368 3.651-1.34 1.74-3.074.811-4.747.477-3.816-.762-8-1.153-11.99-.53-1.882.293-3.737.348-5.47.904-.775.249-1.73.564-2.519.827-.63.21-2.08.815-1.389 1.011",
    fill: "#F69536",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.687 30.331c-2.247.16-4.994-.082-7.13-.526-2.492-.518-3.289-1.73-.197-1.908 3.557-.205 8.907-1.324 12.872-1.52 8.628-.425 17.026-.206 25.144 1.528 1.22.261 2.995.199 3.77 1.11-1.497 1.196-4.921 1.927-5.942 2.632",
    fill: "#6D6063",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.92 25.755c-3.013 1.175-10.477-.13-11.655-2.677-1.925-4.157 6.068-4.5 8.308-4.836 8.228-1.239 17.435-.733 25.868-.319 4.029.198 8.492.148 12.368.985 1.22.264 4.663.764 5.389 1.939 1.285 2.076-1.517 3.889-3.15 4.582-3.935 1.67-8.555-.28-12.511-.718-4.063-.45-8.839-.613-12.833-.006-.977.148-1.963.362-2.88.528",
    fill: "#FEF398",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.95 19.023c-3.723-1.733-2.22-6.722.508-8.742 3.007-2.227 8.409-1.4 12.058-1.4 4.166 0 7.979.656 12.065 1.068 3.408.343 8.202.689 11.003 2.74 1.685 1.236 1.965 3.49 1.04 5.414-1.22 2.529-3.152 1.18-5.508 1.187-2.382.006-4.632-.267-7.038-.267h-6.032",
    fill: "#C8AF66",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#0fe2bone4b)",
    d: "M154.386 49.108h6.57v-4.365h-6.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.555 82.218c-5.346-.364-11.06 2.156-16.068-.546-1.176-.636-5.027-3.099-4.343-4.757.517-1.253 5.293-2.972 6.556-3.535 4.81-2.14 11.48-2.099 16.794-2.338 6.653-.3 13.133.021 19.573.996 2.354.356 4.756 1.479 6.929 2.464 2.082.944 4.69 1.628 5.91 3.552-3.544 3.23-10.184 3.626-14.744 3.83-5.72.255-11.345.223-16.97 0-.404-.016-.81.002-1.213 0",
    fill: "#FEF398",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.036 138.667c-2.618-.273-5.662-1.206-8.751-2.663 6.177-1.96 16.607-2.052 23.509-1.445 6.293.553 17.503-.867 21.383 2.809-7.437 2.482-15.595 4.29-22.241 2.956",
    fill: "#6D6063",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.311 149.762c-2.947-.19-6.818-3.799-6.137-7.015.7-3.31 6-3.59 9.035-3.898 8.533-.866 17.135.693 25.226 1.307 3.715.28 7.5 1.703 11.267 2.323 4.255.7 7.036 5.282 2.236 7.218-3.244 1.308-9.021.665-12.473.844-4.176.216-8.284-.26-12.53-.26-2.8 0-5.646-.154-8.44 0-1.407.078-2.69.238-4.092.26-1.022.017-3.49.016-3.069-.26",
    fill: "#C8AF66",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.506 28.384c14.823-.512 15.845 18.274 10.712 27.87-2.795 5.224-7.94 8.762-14.206 8.038-6.14-.71-8.664-7.78-9.157-12.863-.46-4.753.51-9.832 2.135-14.062 2.335-6.074 5.883-8.228 10.13-8.983",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.596 31.647c6.441-4.652 8.246-17.493-.733-19.448-3.81-.828-7.682.993-9.264 5.244-1.708 4.593-1.18 8.775 1.153 12.447M95.26 64.386c-.865 5.437-1.59 10.114-3.285 14.187M82.12 61.112c-1.018 3.945-3.344 15.075-3.283 14.13M79.93 42.19c-7.498-4.117-9.442 10.703-1.25 11.283M104.814 44.845c7.584-1.351 5.222 11.194-1.89 10.802",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.304 48.017c-1.315 1.486-1.852 2.38-3.285 3.273M79.93 46.925c-.009-.007-3.168-3.186-3.284-3.274M99.293 43.651c-.05 1.577-.05 2.668-.403 4.366M87.249 43.651c-.102 1.74-.252 2.2-.403 3.274M95.13 43.651c.05 1.562 1.008 9.015-3.155 5.714M97.153 54.274c-4.295 0-6.944-.12-10.63-1.892-.22 3.495 1.13 5.798 4.078 6.396 4.022.817 5.804-1.82 6.848-4.504M93.07 76.203c3.344-.86 5.046-1.126 7.003-.713 2.914.614 5.382 1.88 7.109 4.441 2.01 2.98 2.83 6.518 3.903 9.93.915 2.905 1.791 5.792 2.613 8.715.936 3.319 2.279 9.586 2.365 9.46",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.574 108.968c1.855-3.072 12.126-16.736 15.177-21.6.92-1.465 1.807-2.972 3.567-3.213 1.833-.25 3.494.125 5.28.28 3.434.299 5.938.013 10.503-.406 0 1.686-4.57 2.52-5.85 2.64-1.898.18-5.061.176-6.563 1.397-1.112.905-8.205 18.67-12.554 24.876-1.74 2.482-3.34 4.66-5.857 6.507-1.555 1.14-4.39 2.052-6.414 1.536-2.636-.674-5.647-5.114-7.654-8.726M135.93 82.52c-4.547 0-10.87 1.06-15.047-.199-1.657-.5-3.245-2.074-4.306-3.381-.707-.871-.687-1.178.077-2.187 6.231-8.223 38.732-5.614 42.284-4.675 4.223 1.119 9.632 3.193 12.967 5.87-3.562 4.503-16.69 4.428-19.917 4.357",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.253 77.225c6.311 0 37.48-.905 44.893-.452M119.935 74.207c-2.034-.935-4.055-2.594-4.73-4.813-1.026-3.373 1.447-3.94 4.151-4.649 8.005-2.093 16.738-2.815 25.104-2.452 7.71.336 15.96 1.932 23.174 4.685 2.499.953 2.918 3.018.319 4.432-2.072 1.128-4.46 1.308-6.63 1.912-.431.121-.834.245-1.286.288.034.208.14.039.278.113",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.92 64.386c1.735-.439 5.095-1.673 5.543-3.59 1.156-4.957-14.073-5.02-18.651-5.407a218.493 218.493 0 0 0-17.769-.749c-4.115 0-5.4-.246-9.467.15-1.419.138-5.971 1.95-6.553 4.198-.585 2.256 3.689 4.696 5.68 5.248M162.877 55.568c1.515.19 8.578.2 9.028-1.322-6.87-1.747-14.034-3.11-21.178-4.272-6.353-1.033-12.785-.974-19.193-.68-5.75.264-12.087.554-17.66 2.073 2.642 1.197 6.65 2.323 9.568 2.098",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.397 51.514c0-3.014-.13-4.418.034-7.86 3.289-.024 43.715.174 43.715.324 0 2.738 0 6.179-.144 9.495M122.663 43.373c-.076-2.047 0-2.363.152-5.003 1.944-.288 12.117-.138 14.821-.117.09 1.663.203 5.467.326 5.398M136.867 37.669c1.487-1.474 4.924-1.934 6.96-2.14 3.24-.33 6.673-.727 9.958-.574 4.382.204 10.186.93 13.26 4.458 1.558 1.787-1.017 3.25-2.884 3.694-.037.177-.04.36-.026.544",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.922 36.547c.407-.927 1.474-2.235 1.17-3.294-.3-1.043-1.921-1.523-2.924-1.793-3.35-.9-7.047-1.154-10.561-1.502-8.283-.82-17.238-.584-25.409.457-1.566.2-4.054.547-4.71 2.206-.589 1.489.795 4.913 2.08 5.574",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.472 30.666c-3.654 0-7.861-.492-11.124-2.01 2.083-1.076 5.225-1.092 7.575-1.349 3.709-.405 7.519-.726 11.295-.897 7.677-.345 15.87-.55 23.226 1.536.59.168 1.146.247 1.702.6-1.011 1.708-3.811 2.561-5.147 3.101M154.386 49.108h6.57v-4.365h-6.57zM79.93 76.39c-5 0-10.53.768-14.362 4.23-3.85 3.478-6.553 8.18-7.536 13.23",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.354 76.39c-.867 5.957-5.357 9.017-10.123 9.7-5.594.805-10.484-2.46-12.471-7.748-.15-.396-.358-.904-.4-1.23M77.74 106.43c.699-1.507.927-3.742 1.194-5.67.256-1.84.435-3.784 1.218-5.41 2.087.104.378 5.858 1.366 7.12 2.039-2.205 6.43-8.422 8.735-8.62.036 2.21-2.102 5.206-3.1 7.067 1.479-.985 5.695-5.697 7.679-5.04 1.88.622-3.988 5.234-4.491 6.28 2.297-.607 4.709-1.507 7.091-1.557.383 2.094-5.783 3.85-6.967 4.926 1.62.524 4.945-.75 6.078.677-2.442 1.7-4.802 2.42-6.614 2.927-2.291.639-5.242 1.785-7.06 4.364M84.31 113.884c-2.272 3.852-5.338 8.971-7.757 12.778-2.554 4.023-4.885 7.204-9.678 8.922-1.833.657-4.374 1.55-5.834-.164-1.565-1.836-2.128-3.505-2.498-5.757-.808-4.913-.524-10.452-.067-16.17",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.835 106.946c-4.597 5.027-10.35 10.459-14.234 15.278M57.336 93.85c-1.827 5.899-2.695 13.439-2.579 19.611 2.577.13 10.811-.185 14.224.014M70.076 100.398c-.157 6.621-.78 10.116-1.095 16.37M124.199 27.22c-4.913.586-14.48-4.802-5.585-7.264 6.12-1.693 14.155-1.198 20.559-1.258 7.308-.068 15.415-.644 22.388 1.085 1.955.486 6.466 1.375 5.919 3.704-.328 1.394-5.037 3.268-5.53 3.795",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.578 19.643c10.841-9.902-15.871-10.586-20.486-10.787-4.396-.191-11.135-.368-15.087 1.106-3.345 1.246-5.22 7.03-1.15 8.565M128.857 9.822l-.403-8.731M127.013.546h30.658M158.218 1.091v10.913M87.595 89.595c5.893 0 8.96 1.047 14.234.846M102.924 91.668c-.5 6.495-4.16 27.171-4.38 32.739",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.64 124.334c-5.716-.202-9.547-.946-14.235-.946M87.595 111.311c-.14 2.68-.789 7.483-1.095 10.913M87.455 90.577l-.815 6.547M101.829 90.577l-5.475 10.913M95.259 108.037l5.475 15.278M88.69 90.577l8.759 6.547M96.354 115.676l-10.949 6.548M96.161 103.672l-.708 3.274M116.063 102.581l-8.759 4.365",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.907 86.212c1.184 4.799-1.46 51.544-1.981 52.333-.8 1.213-3.17 1.026-4.599 1.022-6.645-.016-26.196.38-28.279-.196-1.56-.43-.775-4.959-.775-5.472",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36 112.402c-.002-6.497 2.354-24.312 2.849-24.94.62-.788 20.88-1.129 23.545-1.16 1.54-.018 5.316-.194 6.455 0",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.595 91.668c-2.868 0-11.281.372-11.281.743 0 3.912-.382 10.604-.763 15.626M76.646 124.407c.137 2.214.19 6.292.19 8.58 0 .19 15.327.219 20.201-.029.447-2.75.412-5.65.412-8.551M102.116 138.593c.297 7.156.673 10.55.457 14.187M60.222 137.502c-.86 3.533-3.167 9.467-3.285 16.37M101.83 152.034c-8.02 0-36.131.247-43.798.401M98.543 152.883c-.004 7.943.056 16.191-.345 24.222-6.372.33-12.266.785-18.604.408-.616-1.993-.907-5.05-1.308-7.077-3.116 3.72-4.582 7.444-5.357 7.444-4.84 0-13.34-.402-18.182-.834 1.106-6.648 3.434-16.513 5.762-24.266",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.354 176.788c-1.194 15.646-1.545 21.944-3.185 32.383-1.75 11.138-3.967 22.112-5.574 33.095M88.788 242.266c-.624 5.004-1.27 8.692-1.462 12.303 3.876.227 7.724 1.41 11.35 2.668 3.447 1.197 8.782 4.062 2.267 4.505-5.508.375-24.079 0-23.17 0M79.93 175.697c0 25.917-4.348 50.316-4.348 76.22 0 3.108-.283 6.386.845 8.9M85.405 197.523c.496 2.304 2.272 4.818 4.38 6.548",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.595 253.178c-1.966 2.09-10.004 4.782-10.95 2.242M86.5 247.378c-3.721-.014-8.034-.403-10.95-.403M90.859 254.27c-.27 1.465-1.04 3.315-1.053 3.273M93.07 255.361c-.55 1.565-.461 2.206-1.095 3.274M73.36 177.624c-1.913 5.227-5.764 33.828-14.862 30.55-5.118-1.842-9.604-11.02-11.914-15.498-3.364-6.519-5.111-12.688-8.473-19.06-2.314-4.386-2.7-5.272-7.777-6.03-2.476-.37-10.496-.128-10.625-3.076 7.658-1.224 16.954-.83 24.874-.371 3.833 7.555 5.66 13.729 11.126 20.075",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.032 176.788c-1.356 5.95-4.546 10.504-2.75 17.461M47.082 165.876c-2.06 0-11.878 1.446-10.878 3.273M51.462 174.606c-2.155.54-8.154 2.343-8.76 3.274M37.18 163.693c-.726 1.76-1.145 2.944-.953 3.274M32.848 163.693a11.16 11.16 0 0 1-1.095 3.274M44.048 162.329c3.181.083 8.747-.603 10.699-3.07-2.855-2.77-14.08-2.007-18.318-2.045-7.615-.068-15.233 0-22.848 0-3.354 0-18.883 1.262-9.529 4.006 6.101 1.79 9.88 1.79 16.736 2.473M5.876 156.054l.292-6.548M6.57 150.253l39.417-.402M48.51 149.506l.43 6.548M7.338 149.506c-2.216-.051-5.596-3.091-6.1-5.24-.798-3.392 1.883-4.22 4.57-4.757 5.567-1.115 12.289-1.01 18.252-.727 6.233.296 12.623 1.023 18.625 2.18 2.134.413 6.009.556 7.599 2.194 1.715 1.767 1.733 5.218-1.12 6.202-.322.11-2.063-.173-1.539-.019",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.177 144.904c-7.116 1.06-14.667-1.744-21.758-2.43-6.508-.626-13.218-.607-19.85-.607M10.239 138.751c-2.324.197-4.669-1.146-6.954-2.652 7.21-2.727 16.651-1.669 24.458-1.669 5.527 0 16.272-.426 20.434 3.055a23.117 23.117 0 0 1-4.782 2.064c-1.118.334-4.162.95-3.363 1.227",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.934 135.32c1.567-.412 2.712-2.435 1.855-3.816-.576-.928-3.89-1.12-4.966-1.35-3.872-.825-8.067-.995-12.253-.995-5.485 0-20.83-1.87-24.095 2.605 1.206 1.56 3.538 2.91 5.812 2.984M36.892 127.68c.015-2.157.395-4.22.328-6.307-7.593-.231-15.208-.382-22.888-.037-.127 2.297-.19 3.668.196 6.01M35.74 120.041c2-.013 3.985-.24 5.868-.96-3.485-3.759-13.751-3.386-18.458-3.547-4.833-.165-13.332-2.112-17.675.1 1.961 2.506 6.038 3.98 8.997 4.345",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#0fe2bone4b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDeliveryGirl);
export default __webpack_public_path__ + "static/media/info_delivery_girl.beb26dc27063a70b6ddf63c41e449c3a.svg";
export { ForwardRef as ReactComponent };